import Hls from 'hls.js';

export function isHLSSupported(): boolean {
  return Hls.isSupported();
}

export function isMSESupported(): boolean {
  return !!window.MediaSource;
}